import { render } from "./VerificationPage.vue?vue&type=template&id=4bbc6082&ts=true"
import script from "./VerificationPage.vue?vue&type=script&lang=ts"
export * from "./VerificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__